import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { LaborSetupItem, LaborSetupJobRule } from 'src/app/shared/models/laborScheduling/LaborSetup.item';

@Component({
	selector: 'app-employee-scheduling-setup',
	templateUrl: './employee-scheduling-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class EmployeeSchedulingSetupComponent implements OnInit, OnDestroy {
	addJobRule: boolean = false;

	changesToSave: boolean = false;

	invalidJobSelection: boolean = false;

	laborSetup: LaborSetupItem;

	jobRule: LaborSetupJobRule;
	jobList: Job[];

	subscriptions: Subscription = new Subscription();
	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}
	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	ngOnInit(): void {
		this.subscriptions.add(
			this.venueService.laborSetup.subscribe((data) => {
				this.laborSetup = data;
				this.laborSetup?.default && (this.changesToSave = true);
			})
		);

		this.subscriptions.add(
			this.venueService.jobList.subscribe((data) => {
				this.jobList = data;
			})
		);
		this.laborSetup?.default && (this.changesToSave = true);
		this.jobList = this.venueService.jobList.value;
	}

	addNewJobRule() {
		this.laborSetup.jobSpecificRules.push(this.jobRule);
		this.addJobRule = false;
		this.jobRule = undefined;
	}

	newJobRule() {
		this.jobRule = new LaborSetupJobRule({
			newJobRule: true,
		});
		this.addJobRule = true;
	}

	cancelNewJobRule() {
		this.jobRule = undefined;
		this.addJobRule = false;
	}

	deleteJobRule(jobRule: LaborSetupJobRule) {
		this.app.confirmation.confirm({
			message: `Delete?`,
			accept: async () => {
				this.laborSetup.jobSpecificRules.splice(
					this.laborSetup.jobSpecificRules.findIndex((i) => i.jobId === jobRule.jobId),
					1
				);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	updateJobRule(jobRule: LaborSetupJobRule) {
		const existingIdx = this.laborSetup.jobSpecificRules.findIndex((i) => i.jobId === jobRule.jobId);
		if (existingIdx !== -1) {
			this.laborSetup.jobSpecificRules[existingIdx] = jobRule;
		} else {
			this.laborSetup.jobSpecificRules.push(jobRule);
		}
		this.changesToSave = true;
	}

	async save() {
		this.laborSetup.default = false;
		this.laborSetup.jobSpecificRules?.forEach((jobRule) => {
			delete jobRule.newJobRule;
		});
		this.app.loading(true);
		const resp = await this.focuslink.laborSetupSave(this.venueService.subscriptionVenue.value.key, this.laborSetup);
		this.venueService.laborSetup.next(new LaborSetupItem(resp));
		this.app.loading(false);
	}

	validateJobSelection() {
		this.invalidJobSelection = this.laborSetup.jobSpecificRules.some((i) => i.jobId === this.jobRule.jobId);
	}
}
